export const paymentMethods = {
    "1": "Tarjeta de crédito",
    "2": "Cheque",
    "3": "Transferir",
    "4": "Depósito en ventanilla",
    "5": "Configuración manual", // Legacy Payment
    "6": "Cargo bancario de Bllink",
    "7": "Cheque automático",
    "8": "Registro de inquilino",
    "9": "No determinado",
};
